import { useMarketAccountsContext } from '@talos/kyoko';
import { getMarketAccountDisplayNames } from '../MarketAccountSelectionList/utils';

export function MarketAccountNames({ marketAccounts }: { marketAccounts: string[] }) {
  const { marketAccountsByName } = useMarketAccountsContext();
  return <>{getMarketAccountDisplayNames(marketAccounts, marketAccountsByName).join(', ')}</>;
}
